import { Box, Divider, Paper, Stack, SxProps, Theme, Typography } from "@mui/material";
import React from "react";
import IconComponent from "./IconComponent";

type PanelProps = {
  headerLabel?: string;
  headerIconName?: string;
  headerActions?: React.ReactNode;
  compact?: boolean;
  children: React.ReactNode;
  sx?: SxProps<Theme>;
};

const Panel: React.FC<PanelProps> = ({ headerLabel, headerIconName, headerActions, compact, children, sx }) => {
  return (
    <Paper sx={{ p: 2, borderRadius: 2, display: "flex", flexDirection: "column", ...sx }} elevation={3}>
      {headerLabel && (
        <>
          <Stack direction="row" alignItems="center" spacing={1} sx={{ mb: 0.5 }}>
            {headerIconName && <IconComponent iconName={headerIconName} />}
            <Typography variant={compact ? "body1" : "h6"} gutterBottom sx={{ flex: 1 }}>
              {headerLabel}
            </Typography>
            {headerActions && <Box>{headerActions}</Box>}
          </Stack>
          {!compact && <Divider flexItem sx={{ mb: 2 }} />}
        </>
      )}
      <Box sx={{ flex: 1 }}>{children}</Box>
    </Paper>
  );
};

export default Panel;
